﻿function trackMostPopularLinkClick(event) {
    const link = $(event.target);
    const externalUrl = link.attr('href');
    window.sendMostPopularLinkClick(externalUrl);
}

function trackRelatedLinkClick(event) {
    const link = $(event.target);
    const externalUrl = link.attr('href');
    window.sendRelatedLinkClick(externalUrl);
}

function trackFeaturedEventLinkClick(event) {
    const link = $(event.target);
    const externalUrl = link.attr('href');
    window.sendFeaturedEventLinkClick(externalUrl);
}

function trackSubscribeLinkClick(event) {
    const link = $(event.target);
    const externalUrl = link.attr('href');
    window.sendSubscribeLinkClick(externalUrl);
}

function trackFeatureLinkClick(event) {
    const link = $(event.target);
    const externalUrl = link.attr('href');
    window.sendFeatureLinkClick(externalUrl);
}

function trackMainTagClick(event) {
    const link = $(event.target);
    const externalUrl = link.attr('href');
    window.sendMainTagClick(externalUrl);
}


export function setupGoogleAnalytics() {
    setupFunctions();

    $(document).on('click', 'a[data-ga-track-most-popular-link-click]', trackMostPopularLinkClick);
    $(document).on('click', 'a[data-ga-track-related-link-click]', trackRelatedLinkClick);
    $(document).on('click', 'a[data-ga-track-featured-event-link-click]', trackFeaturedEventLinkClick);
    $(document).on('click', 'a[data-newsletter-signup-button]', trackSubscribeLinkClick);
    $(document).on('click', 'a[data-ga-track-feature-link-click]', trackFeatureLinkClick);
    $(document).on('click', 'a[data-main-tag-click]', trackMainTagClick);
}

function setupFunctions() {
    window.sendMostPopularLinkClick = function (externalUrl) {
        if (typeof ga !== "undefined") {
            ga(ga.getAll()[0].get("name") + ".send", "event", "mostpopulararticles", "click", externalUrl);
        }
    };

    window.sendRelatedLinkClick = function (externalUrl) {
        if (typeof ga !== "undefined") {
            ga(ga.getAll()[0].get("name") + ".send", "event", "relatedarticles", "click", externalUrl);
        }
    };

    window.sendFeaturedEventLinkClick = function (externalUrl) {
        if (typeof ga !== "undefined") {
            ga(ga.getAll()[0].get("name") + ".send", "event", "featuredevent", "click", externalUrl);
        }
    };

    window.sendSubscribeLinkClick = function (externalUrl) {
        if (typeof ga !== "undefined") {
            ga(ga.getAll()[0].get("name") + ".send", "event", "subscribe", "click", externalUrl);
        }
    };

    window.sendFeatureLinkClick = function (externalUrl) {
        if (typeof ga !== "undefined") {
            ga(ga.getAll()[0].get("name") + ".send", "event", "featurelink", "click", externalUrl);
        }
    };
    window.sendMainTagClick = function (externalUrl) {
        if (typeof ga !== "undefined") {
            ga(ga.getAll()[0].get("name") + ".send", "event", "primarytags", "click", externalUrl);
        }
    };
}
